module.exports = {
  route: {
    map: 'Mapa',
    dashboard: 'Dashboard',
    reports: 'Informes',
    report: 'Informe',
    report_trip_title: 'Informe de viajes',
    report_location_title: 'Informe de posiciones',
    report_zone_crossing: 'Informe de zonas',
    settings: 'Configuraciones',
    duration: 'Duracción'
  },
  map: {
    geofence_create_title: 'Nueva geocerca',
    geofence_create_name: 'Por favor indicar o nombre da geocerca...',
    geofence_created: 'Geocerca criada con éxito!',
    geofence_create_canceled: 'Creación de geocerca cancelada!',
    poi_create_title: 'Nuevo PDI',
    poi_create_name: 'Por favor indicar o nombre del PDI...',
    poi_created: 'PDI criado con éxito!',
    poi_create_canceled: 'Creación de PDI cancelada!',
    create_confirm: 'Confirmar',
    create_cancel: 'Cancelar',
    loading: 'Cargando...'
  },
  vehicleList: {
    title: 'Vehículos',
    search: 'Buscar...',
    column_name: 'Nombre',
    column_speed: 'Km/h',
    column_lastUpdate: 'Ultima actualización'
  },
  vehicleTable: {
    immobilize: 'Inmovilizar',
    de_immobilize: 'Movilizar',
    send_immobilization: 'Enviar comando de inmovilización para el vehículo',
    send_de_immobilization: 'Enviar comando de movilización para el vehículo',
    all_vehicles: 'Todos',
    moving_vehicles: 'En movimiento',
    idle_vehicles: 'Inactivo',
    stopped_vehicles: 'Detenido',
    disconnected_vehicles: 'Desconocido'
  },
  vehicleDetail: {
    show_route: 'Mostrar ruta'
  },
  poiTable: {
    showPOIs: 'Mostar PDIs',
    edit_poi: 'Editar',
    delete_poi: 'Apagar'
  },
  dashboard: {
    startdate: 'Fecha de inicio',
    enddate: 'Fecha de fin',
    period_lastweek: 'Ultima semana',
    period_lastmonth: 'Ultimo mes',
    period_last3month: 'Ultimos 3 meses'
  },
  navbar: {
    profile: 'Perfil',
    settings: 'Ajustes',
    logout: 'Salir'
  },
  login: {
    login_password: 'Contraseña',
    login_button: 'Iniciar',
    login_password_warn: 'La contraseña no puede tener menos de 6 dígitos',
    login_user: 'Usuario'
  },
  profile: {
    user_account: 'Usuário',
    user_name: 'Nombre',
    user_email: 'E-mail',
    user_password: 'Contraseña',
    user_phone: 'Teléfono',
    user_language: 'Idioma',
    user_timezone: 'Huso horario',
    user_update_button: 'Gravar',
    user_updated: 'La información del usuario ha sido actualizada.',
    user_name_required: 'El campo de nombre es obligatorio',
    user_email_required: 'Por favor, indicar un e-mail válido.',
    user_password_lengh: 'La contraseña no puede tener menos de 6 dígitos'
  },
  settings: {
    map: 'Mapa',
    vehicles: 'Vehículos',
    title: 'Configuraciones',
    route_match: 'Rota na estrada',
    alerts: 'Alertas',
    alerts_type: 'Tipo',
    alerts_notificators: 'Vias',
    alert_ignitionOff: 'Motor apagado',
    alert_ignitionOn: 'Motor encendido',
    alert_geofenceEnter: 'Entrada en geocerca',
    alert_geofenceExit: 'Salida de geocerca',
    alert_deviceOverspeed: 'Traspassos de velocidad',
    alert_deleted: 'Alerta ha sido apagado.',
    alert_delete_info: 'Desea apagar la alerta de ',
    alert_delete_title: 'Apagar Alerta',
    alert_edit_confirm: 'Confirmar',
    alert_edit_cancel: 'Cancelar',
    alert_created: 'Alerta creada con éxito!',
    alert_updated: 'Alerta actualizada con éxito!',
    alert_add: 'Añadir Alerta',
    alert_edit: 'Editar Alerta',
    alert_delete: 'Apagar Alerta',
    alert_overspeed_warning: 'Vehículo sin velocidad máxima establecida',
    alert_geofences_warning: 'Vehículo sin geocercas asociadas',
    alert_associate_geofences: 'Associar Geocercas',
    alert_form_type: 'Tipo:',
    alert_form_type_placeholder: 'Seleccionar tipo de alerta',
    alert_form_vehicles: 'Vehículos:',
    alert_form_geofences: 'Geocercas:',
    alert_form_all_vehicles: 'Todos los vehículos',
    alert_form_vehicles_placeholder: 'Seleccione vehículos',
    alert_form_notificator_web: 'Web',
    alert_form_notificator_email: 'E-mail',
    alert_form_notificator_sms: 'SMS',
    alert_form_confirm: 'Gravar',
    alert_form_cancel: 'Cancelar',
    alert_form_geofences_placeholder: 'Seleccione geocercas',
    vehicle_edit: 'Editar Vehículo',
    vehicle_name: 'Nombre',
    vehicle_licenseplate: 'Placa',
    vehicle_model: 'Modelo',
    vehicle_speed_limit: 'Límite de Velocidad',
    vehicle_form_cancel: 'Cancelar',
    vehicle_form_confirm: 'Gravar',
    vehicle_form_name: 'Nombre',
    vehicle_form_model: 'Modelo',
    vehicle_form_speed_limit: 'Límite de Velocidad (Km/h)',
    vehicle_updated: 'Veículo actualizado com sucesso!'
  },
  geofence: {
    showGeofences: 'Mostrat Geocercas',
    geofence_name: 'Nombre',
    geofence_edit: 'Editar',
    geofence_delete: 'Apagar',
    geofence_deleted: 'A geocerca ha sido apagada',
    geofence_delete_info: '¿Quieres apagar geocerca ',
    geofence_delete_title: 'Apagar Geocerca',
    geofence_edit_title: 'Editar Geocerca',
    geofence_edit_name: 'Por favor indicar el nombre de geocerca...',
    geofence_edit_confirm: 'Confirmar',
    geofence_edit_cancel: 'Cancelar',
    geofence_edit_canceled: 'Editar cancelado',
    geofence_edited: 'Geocerca editada con éxito!',
    poi_delete_info: 'Pretende apagar o PDI ',
    poi_delete_title: 'Apagar PDI',
    poi_edited: 'PDI editado con éxito!',
    poi_deleted: 'PDI ha sido apagado',
    poi_edit_title: 'Editar PDI',
    poi_edit_name: 'Por favor indicar el nombre de PDI...',
    searchGeofence: 'Procurar Geocerca',
    edit_geofence: 'Editar',
    delete_geofence: 'Apagar'
  },
  report: {
    alarm: 'Alarma',
    distanceIn: 'Kms adentro',
    distanceOut: 'Kms afuera',
    temperature: 'Temperatura',
    select_vehicles: 'Seleccione vehículos',
    select_vehicles_placeholder: 'Vehículos',
    select_geofences: 'Seleccione geocercas',
    select_geofences_placeholder: 'Geocercas',
    select_period: 'Seleccione periodo',
    date_start: 'Fecha de inicio',
    date_end: 'Fecha de fin',
    generate_report: 'Generar informe',
    period: 'Periodo',
    user: 'Utilizador',
    titleTripReport: 'Informe de Viajes',
    titleLocationReport: 'Informe de Posiciones',
    titleSpeedingReport: 'Informe de Excesos de Velocidad',
    titleZoneReport: 'Informe de Zonas',
    titleRefuelingReport: 'Informe de Repostajes',
    titleFuelConsumptionReport: 'Informe de Consumos',
    titleFuelDropReport: 'Fuel Drop Report',
    titleEventsReport: 'Informe de Eventos',
    titleActivityReport: 'Informe de Actividad',
    titleKmsReport: 'Informe de Kms',
    titleIdleReport: 'Informe de Ralenti',
    titleMachinesReport: 'Informe de Maquinas',
    titleStopReport: 'Informe de Paradas',
    titleSensorReport: 'Informe de Sensores',
    from: 'De',
    to: 'a',
    headerStartAddress: 'Lugar de início',
    headerDistance: 'Distancia recorrida',
    headerDrivingTime: 'Tiempo de conducción',
    headerMaxSpeed: 'Velocidad máxima',
    date: 'Fecha',
    start: 'Início',
    end: 'Fin',
    stopped: 'Ha Parado',
    yes: 'Sí',
    no: 'No',
    endAddress: 'Destino',
    tripTime: 'Duración',
    idleTime: 'Ralenti',
    stopTime: 'Parada',
    distance: 'Distancia',
    speed: 'Velocidad',
    overspeed: 'Inicio de la alarma',
    roadSpeedLimit: 'Limite en la calle',
    avgSpeed: 'Vel.Média',
    maxSpeed: 'Vel.Max',
    driver: 'Conductor',
    group: 'Grupo',
    address: 'Dirección',
    ignition: 'Motor',
    ignitionOn: 'Encendido',
    ignitionOff: 'Apagado',
    enter: 'Entrada',
    exit: 'Salida',
    geofence: 'Geocerca',
    duration: 'Duracción',
    vehicles: 'Vehículos',
    vehicle: 'Vehículo',
    consumption: 'Consumo (L)',
    avg_consumption: 'Consumo (L/100)',
    avg_consumption_by_liters: 'Consumo (Kms/L)',
    odometer: 'Km',
    startOdometer: 'Start (Km)',
    endOdometer: 'End (Km)',
    spentFuel: 'Consumo',
    engineHours: 'Utilización (HH:mm)',
    totalEngineHours: 'Utilización Total (H:m)',
    driverHours: 'Tiempo de Conducción (H:m)',
    refueling: 'Repostajes',
    fueldrop: 'Combustível Perdido (L)',
    totalRefueled: 'Total Cargado',
    totalFuelDrops: 'Total Fuel Drops',
    totalFuelDropLiters: 'Total Fuel Lost',
    speedLimit: 'Límite de Velocidad',
    eventType: 'Evento',
    info: 'Información',
    event_ignitionOff: 'Motor Apagado',
    event_ignitionOn: 'Motor Encendido',
    event_deviceOverspeed: 'Traspassos de velocidad',
    event_geofenceEnter: 'Entrada en Geocerca',
    event_geofenceExit: 'Salida de Geocerca',
    event_deviceFuelDrop: 'Perda de Combustível',
    event_driverChanged: 'Conductor Cambiado',
    event_sos: 'SOS',
    event_powerOn: 'Tomada de Força',
    event_powerCut: 'Corte de Corrente',
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    sunday: 'Domingo',
    weekDay: 'Dia da Semana',
    unsubscribeTripReport: 'Si no desea recibir estos emails por favor ingrese a %url% y elimine la opción en los Ajustes / Reportes ',
    unsubscribeLocationsReport: this.unsubscribeTripReport,
    unsubscribeSpeedingReport: this.unsubscribeTripReport,
    unsubscribeZoneReport: this.unsubscribeTripReport,
    unsubscribeRefuelingReport: this.unsubscribeTripReport,
    unsubscribeFuelDropReport: this.unsubscribeTripReport,
    minimumMinutes: 'Tiempo mínimo',
    maximumSpeed: 'Velocidad máxima',
    minutes: 'Minutos',
    zone: 'Zona',
    firstIn: 'Primeira Entrada',
    lastOut: 'Última Saída',
    timeIn: 'Tempo Adentro',
    timeOut: 'Tempo Afuera',
    maxTemp: 'Temp.Max',
    minTemp: 'Temp.Min',
    avgTemp: 'Temp.Média',
    total: 'Total'
  },
  layout: {
    deviceOnline: 'Dispositivo en línea',
    deviceMoving: 'Dispositivo en movimiento',
    deviceStopped: 'Dispositivo parado',
    ignitionOff: 'Motor apagado',
    ignitionOn: 'Motor encendido',
    deviceOverspeed: 'Traspassos de velocidad',
    geofenceEnter: 'Entrada en geocerca',
    geofenceExit: 'Salida de geocerca',
    deviceFuelDrop: 'Fuel Drop',
    driverChanged: 'Conductor cambiado',
    sos: 'SOS',
    powerOn: 'Power Take-Off',
    device: 'Vehículo',
    time: 'Fecha',
    address: 'Address',
    driver: 'Motoristas',
    group: 'Grupo',
    in: 'en',
    fuelDropInfo: 'Fuel drop greater than '
  }
}
